import React, { useState } from "react";
import "./Login.css";
import Qcr from "../../images/qcr.png";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Modal,
  InputGroup,
  Toast,
} from "react-bootstrap";
import {
  GetRequestorCustomer,
  OTPLogin,
  ValidateLogin,
} from "../../apis/LoginAPI";
import md5 from "md5";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../slices/authSlice";
import { StoreUser } from "../slices/authLocal";

export default function Login() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [userId, setUserId] = useState(0);
  const [requestorId, setRequestorId] = useState(0);
  const [show, setShow] = useState(false);
  const [showWrongUser, setShowWrongUser] = useState(false);
  const [showWrongOtp, setWrongOtp] = useState(false);
  const [showLoginSuccess, setLoginSuccess] = useState(false);
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(true);
  const [otpIsDisabled, setOTPIsDisabled] = useState(true);
  const [validated, setValidated] = useState(false);
  const [showLoginLoader, setShowLoginLoader] = useState(false);
  //
  const handleEnable = (e) => {
    setShow(false);
    //setIsDisabled((current) => !current);
  };
  //
  const handleClose = (e) => {
    setShowWrongUser(false);
  };

  const handlePassword = (e) => {
    if (e.target.value.length === 0) setIsDisabled(true);
    else setIsDisabled((current) => (!current ? current : false));

    setPassword(e.target.value);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    }
    setValidated(true);
    var pwd = md5(password);
    setShowLoginLoader(true);
    var result = await ValidateLogin({
      useremail: email,
      password: pwd.toUpperCase(),
    });
    //
    if (e.key === "Enter") {
      e.preventDefault();
      handleLogin();
    }
    setIsDisabled((current) => !current);
    if (result.status === 200) {
      setRole(result.data.role);
      setUserId(result.data.user_id);
      setRequestorId(result.data.requestor_id);
      setShow(true);
      setShowLoginLoader(false);
    } else if (result.status === 201) {
      setShowWrongUser(true);
      setShowLoginLoader(false);
    }
  };
  // OTP
  const handleOtp = (e) => {
    if (e.target.value.length < 5) setOTPIsDisabled(true);
    else setOTPIsDisabled(false);
    setOtp(e.target.value);
    if (e.target.value.length === 5)
      document.getElementById("submitOTP").focus();
  };
  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    var result = await OTPLogin({
      useremail: email,
      otp: otp,
    });

    if (result.status === 200) {
      var token = result.data.token;
      //console.log(requestorId);
      if (requestorId != 0) {
        var requestorData = await GetRequestorCustomer(requestorId);
        const loginData = {
          userid: userId,
          useremail: email,
          userrole: role,
          customerid: requestorData.data.customerid,
          requestorid: requestorId,
          customerlogo: requestorData.data.customerlogo,
          usertoken: token,
        };
        dispatch(loginSuccess(loginData));
        StoreUser(loginData);
      } else {
        const loginData = {
          userid: userId,
          useremail: email,
          userrole: role,
          customerid: 0,
          requestorid: 0,
          customerlogo: 0,
          usertoken: token,
        };
        dispatch(loginSuccess(loginData));
        StoreUser(loginData);
      }
      if (role === "Requestor") navigate("/Customer/Dashboard");
      else if (role.includes("Admin")) navigate("/Admin/Dashboard");
      else if (role.includes("Investigator"))
        navigate("/Investigator/Dashboard");
      else if (role.includes("QA")) navigate("/QA/Dashboard");
    } else if (result.status === 202) setWrongOtp(true);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col className="p-0">
            <div className="login-wrapper">
              <Container fluid>
                <div className="login-wrapper-inner">
                  <div className="login-form">
                    <div className="qcryearslogo">
                      <img src={Qcr} alt="QCR" width={149} />
                    </div>
                    <h1>QCR Customer Portal Login</h1>
                    <Form
                      className="login-box"
                      noValidate
                      validated={validated}
                      onSubmit={handleLogin}
                    >
                      <Form.Group className="mb-3" controlId="formBasicName">
                        <Form.Control
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Enter Email"
                          required
                        />
                      </Form.Group>
                      <Form.Group
                        className="mb-3"
                        controlId="formBasicPassword"
                      >
                        <Form.Control
                          type="password"
                          value={password}
                          onChange={handlePassword}
                          placeholder="Enter Password"
                          required
                        />
                      </Form.Group>
                      <FormGroup className="mb-4">
                        <Link
                          className="forgot-button mb-4"
                          variant="link"
                          to="/ForgotPassword"
                          path="ForgotPassword"
                        >
                          Forgot Password?
                        </Link>
                      </FormGroup>
                      <Button
                        className={
                          isDisabled ? "login-button disabled" : "login-button"
                        }
                        variant="primary"
                        type="submit"
                        onClick={handleLogin}
                      >
                        Log In
                        <Loader visible={showLoginLoader} ibutton={true} />
                      </Button>
                    </Form>
                  </div>
                </div>
              </Container>
            </div>
          </Col>
        </Row>
      </Container>
      {/* OPT Modal */}
      <Modal
        className="logOTPmodal"
        centered
        backdrop="static"
        show={show}
        onHide={handleEnable}
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="otp-lock-icon">
            <i className="fas fa-lock"></i>
          </div>
          <h4 className="otp-title">OTP Verification </h4>
          <p className="otp-msg">
            We've sent a verification code to your associated email.
          </p>
          <Form onSubmit={handleOtpSubmit} noValidate validated={validated}>
            <InputGroup>
              <Form.Control
                onChange={handleOtp}
                placeholder="Enter 5 Digit OTP"
                aria-label="Enter OTP"
                aria-describedby="basic-addon1"
                maxLength={5}
                required
              />
            </InputGroup>
            <Button
              id="submitOTP"
              type="submit"
              className={otpIsDisabled ? "verify-otp disabled" : "verify-otp"}
              onClick={handleOtpSubmit}
            >
              Verify
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      {/* Wrong User */}
      <Modal
        className="logOTPmodal"
        centered
        backdrop="static"
        show={showWrongUser}
        onHide={() => setShowWrongUser(false)}
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="otp-lock-icon">
            <i className="fas fa-user"></i>
          </div>
          <h4 className="otp-title">User not validated</h4>
          <p className="otp-msg">
            Email or Password is incorrect <br /> Please try again with correct
            Email and Password
          </p>
          <Button type="submit" className="verify-otp" onClick={handleClose}>
            OK
          </Button>
        </Modal.Body>
      </Modal>
      {/* OTP did not match */}
      <Toast
        className="wrong-otp-toast"
        position="top-end"
        show={showWrongOtp}
        onClose={() => setWrongOtp(false)}
        delay={3000}
        autohide
      >
        <Toast.Body>
          <h3>Wrong OTP</h3>
          <p>OTP did not match</p>
        </Toast.Body>
      </Toast>
      {/* Successfully Loged in */}
      <Toast
        className="wrong-otp-toast"
        position="top-end"
        show={showLoginSuccess}
        onClose={() => setLoginSuccess(false)}
        delay={3000}
        autohide
      >
        <Toast.Body>
          <h3>Loged in</h3>
          <p>Successfully Loged in</p>
        </Toast.Body>
      </Toast>
    </>
  );
}
